import '@css/admin_css.scss';

import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { blockStrayFileDrops } from 'src/lib/blockStrayFileDrops';
import { installChunkFailureRecovery, startBuildUpdateWatch } from 'src/lib/buildUpdate';
import { guardPageTranslation } from 'src/lib/guardPageTranslation';
import { App } from './App';

// makes the use of Map and Set in immer.js possible
enableMapSet();
guardPageTranslation();

setDateTimeLocalization();
blockStrayFileDrops();

// Prompt rather than reload: this is the backoffice, and a reload mid-form loses unsaved work.
startBuildUpdateWatch({ auto: false });
installChunkFailureRecovery();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
